import { Checkbox, FormControl, Grid2, IconButton, InputLabel, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import React, { useState, useEffect } from "react";
import { set } from "lodash";
import deliveryServices from 'app/services/delivery-services';
import JumboConfirmDialog from "@jumbo/components/JumboConfirmDialog";

const downloadFile = (fileUrl) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const uploadDeliveryDocument = async ({ deliveryId, selectedFile, signed, documentKindName }) => {
  if (documentKindName === "Toma de conocimiento") {
    return deliveryServices.sendRiskAcknowledgementFile(deliveryId, selectedFile, signed);
  } else if (documentKindName === "Recepción conforme") {
    return deliveryServices.sendContentReceptionFile(deliveryId, selectedFile, signed);
  }
};

function SingularDocument({title, details, documentKindName, deliveryId, refreshDocumentsData}) {
  const [file, setFile] = useState(null);
  const lowerCaseTitle = title.toLowerCase()
  const titleIdLike = lowerCaseTitle.split(" ").join("-")
  const documentKindNameIdLike = documentKindName.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, "").split(" ").join("-")
  const elementId = documentKindNameIdLike + "-" + titleIdLike
  const [present, setPresent] = useState(details["present"])
  const formData = new FormData();
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState({
    open: false,
    shippingDocId: null
  });

  const confirmDestroyFile = () => {
    const { shippingDocId } = confirmDeleteDialog;

    deliveryServices.destroyShippingDoc(shippingDocId)
      .then(() => {
        setPresent(false);
        if (refreshDocumentsData) {
          refreshDocumentsData();
        }
      })
      .catch((error) => {
        console.error("❌ Error al eliminar archivo:", error);
        alert("Hubo un problema al eliminar el archivo. Por favor, intenta nuevamente.");
      })
      .finally(() => {
        setConfirmDeleteDialog({ open: false, shippingDocId: null });
      });
  };

  const uploadFile = (event) => {
    if (event.target.files) {
      const selectedFile = event.target.files[0];
      setFile(selectedFile);

      const signed = title === "Documento firmado";
      console.log("➡️ Subiendo archivo", {
        deliveryId,
        signed,
        filename: selectedFile.name
      });

      uploadDeliveryDocument({ deliveryId, selectedFile, signed, documentKindName })
        .then((data) => {
          console.log("✅ Archivo subido correctamente:", data);
          setPresent(true);
          if (refreshDocumentsData) refreshDocumentsData();
        })
        .catch((err) => {
          console.error("❌ Error al subir archivo:", err);
          alert("Error al subir el archivo. Intenta nuevamente.");
        });
      }
  };
  const origin = details["origin"]
  const warning = details["warning"]
  const error = details["error"]
  const destroyable = present && details["destroyable"]
  const fileUrl = details["file_url"]
  return (
    <div>
      <Checkbox
        disabled
        color="primary"
        checked={present}
        inputProps={{
          'aria-label': 'select all desserts',
        }}
      /> {title}
      <Tooltip title={"Descargar " + lowerCaseTitle} placement="top-start">
        <IconButton
          sx={{ display: present ? 'inline' : 'none' }}
          id="basic-button"
          aria-controls={'basic-menu'}
          aria-haspopup="true"
          aria-expanded={'true'}
          onClick={() => downloadFile(fileUrl)}
        >
          <FileDownloadOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={"Subir " + lowerCaseTitle} placement="top-start">
        <IconButton
          sx={{ display: present ? 'none' : 'inline' }}
          id="basic-button"
          aria-controls={'basic-menu'}
          aria-haspopup="true"
          aria-expanded={'true'}
        >
          <label htmlFor={"file-upload-" + elementId}>
            <FileUploadOutlinedIcon />
          </label>
          <input style={{ display: 'none' }} id={"file-upload-" + elementId} type="file" onChange={uploadFile} />
        </IconButton>
      </Tooltip>
      <Tooltip title={destroyable ? "Eliminar " + lowerCaseTitle : null} placement="top-start">
        <span>
          <IconButton
            sx={{ display: 'inline', verticalAlign: 'middle' }}
            disabled={!destroyable}
            onClick={() =>
              setConfirmDeleteDialog({
                open: true,
                shippingDocId: details.id
              })
            }
          >
            <DeleteOutline />
          </IconButton>
        </span>
      </Tooltip>
      {origin && (
        <Typography variant="caption"> Origen: {origin} </Typography>
      )}
      {warning && (
        <Typography variant="caption" sx={{ display: 'inline'}} color={'warning'}><ErrorIcon color={'warning'} style={{ verticalAlign: 'sub' }} /> {warning}</Typography>
      )}
      {error && (
        <Typography variant="caption" sx={{ display: 'inline'}} color={'error'}><ErrorIcon color={'error'} style={{ verticalAlign: 'sub' }} /> {error}</Typography>
      )}
      <JumboConfirmDialog
        open={confirmDeleteDialog.open}
        title="Eliminar documento"
        message={`¿Estás seguro que deseas eliminar este ${lowerCaseTitle}? Esta acción no es reversible.`}
        onClose={() =>
          setConfirmDeleteDialog({ open: false, shippingDocId: null })
        }
        onConfirm={confirmDestroyFile}
      />
    </div>
  )
}

function DocumentKindOriginalAndSigned({documentKindName, details, handleInfoToSend, setDisabledSaveBtn, deliveryId, refreshDocumentsData}) {
  const [documentType, setDocumentType] = React.useState('');
  const [disabledType, setDisabledType] = React.useState(false);
  const [typeOptions, setTypeOptions] = React.useState([]);
  const [showTypeOptions, setShowTypeOptions] = React.useState(false);
  const documentKindNameIdLike = documentKindName.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, "").split(" ").join("-")

  React.useEffect(() => {
    if (details && details["typeOptions"]) {
      setTypeOptions(details["typeOptions"])
      setShowTypeOptions(details["typeOptions"].length > 1)
    } else {
      setShowTypeOptions(false)
    }
    if (details && details["type"] && typeOptions.map((opt) => opt.value).includes(details["type"])) {
      setDocumentType(details["type"])
      // In the back we should take care of setting type with the original file setting
      // if there is no original file we don't set the type, it's allowed to be edited
      setDisabledType(true)
    } else if (details && !documentType && showTypeOptions) {
      setDocumentType(typeOptions[0].value)
    }
  }, [details, documentType, typeOptions, showTypeOptions])

  const handleChange = (event) => {
    setDocumentType(event.target.value);
    setDisabledSaveBtn(false);
    handleInfoToSend({contentReception: {documentType: event.target.value}})
  };

  return (
    <Grid2>
      { details &&
        <Typography variant="h5" component="div">
          {documentKindName}
        </Typography>
      }
      { showTypeOptions &&
        <FormControl sx={{ m: 1, width: 200 }}>
          <InputLabel id={"type-select-label" + documentKindNameIdLike}>Tipo</InputLabel>
          <Select
            labelId="type-select-label"
            id="type-select"
            value={documentType}
            label="Tipo"
            onChange={handleChange}
            disabled={disabledType}
            required
            autoFocus
          >
            { typeOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      }
      { details &&
        <SingularDocument title="Documento original" details={details["original"]} documentKindName={documentKindName} deliveryId={deliveryId} refreshDocumentsData={refreshDocumentsData}/>
      }
      { details &&
        <SingularDocument title="Documento firmado" details={details["signed"]} documentKindName={documentKindName} deliveryId={deliveryId} refreshDocumentsData={refreshDocumentsData}/>
      }
    </Grid2>
  )
}

const DeliveryDocuments = ({ documentsData = {}, handleInfoToSend, setDisabledSaveBtn, deliveryId, refreshDocumentsData}) => {
  const defaultStructure = {
    "toma de conocimiento": {
      original: { present: false, destroyable: false },
      signed: { present: false, destroyable: false },
      type: null,
      typeOptions: [],
    },
    "recepción conforme": {
      original: { present: false, destroyable: false },
      signed: { present: false, destroyable: false },
      type: null,
      typeOptions: [],
    },
  };

  const safeDocumentsData = {
    ...defaultStructure,
    ...documentsData
  };

  return (
    <div>
      <DocumentKindOriginalAndSigned
        documentKindName="Toma de conocimiento"
        details={safeDocumentsData["toma de conocimiento"]}
        handleInfoToSend={handleInfoToSend}
        setDisabledSaveBtn={setDisabledSaveBtn}
        deliveryId={deliveryId}
        refreshDocumentsData={refreshDocumentsData}
      />
      <br />
      <DocumentKindOriginalAndSigned
        documentKindName="Recepción conforme"
        details={safeDocumentsData["recepción conforme"]}
        handleInfoToSend={handleInfoToSend}
        setDisabledSaveBtn={setDisabledSaveBtn}
        deliveryId={deliveryId}
        refreshDocumentsData={refreshDocumentsData}
      />
    </div>
  );
};

export default DeliveryDocuments;
